import PassagePlanNavigation from './PassagePlanNavigation'

export default PassagePlanNavigation
